import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourSummaryComponent } from './tour-summary.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MotePipesModule } from '../../pipes/mote-pipes.module';



@NgModule({
    declarations: [
        TourSummaryComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        MotePipesModule
    ],
    exports: [
        TourSummaryComponent
    ]
})
export class TourSummaryModule { }
